<template>
    <ForgotPassword/>
</template>
<script>
import ForgotPassword from '../components/security/ForgotPassword.vue'
export default {
    components:{
        ForgotPassword
    }
};
</script>